<template>
  <div>
    <div>
      <el-button
        type="primary"
        style="margin-bottom:20px;"
        @click="showAddTemplateHandle">新建模板</el-button>
      <el-table
        :data="listData"
        width="80%"
        style="margin-bottom:100px;"
        border>
        <el-table-column
          v-for="item in columns()"
          :key="item.id"
          :label="item.label"
          :prop="item.prop"
        />
        <el-table-column
          label="操作"
          width="350px">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="small"
              @click="editTitle(scope.row.title,scope.row.id)"
            >编辑标题</el-button>
            <el-button
              type="success"
              size="small"
              @click="editContent(scope.row.name,scope.row.id)"
            >编辑</el-button>
            <el-button
              type="danger"
              size="small"
              @click="deleteFlow(scope.row.id)">删除</el-button>
            <el-button
              icon="el-icon-search"
              size="small"
              @click="lookTemplate(scope.row.id)">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :visible.sync="showAddTemplate"
      title
      center>
      <div style="display:flex;align-items:center;margin-bottom:10px;">
        模板名称 :&nbsp;
        <el-input
          v-model="templateName"
          placeholder="请输入模板名称"
          style="width:30%" />
      </div>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="showAddTemplate = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addTemplate">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="showAddButton"
      title
      center>
      <el-button
        type="primary"
        style="margin-bottom:10px;"
        @click="showFlowAdd = true">添加主流程</el-button>
      <div v-if="showFlowAdd">
        <el-form>
          <el-form-item label="序号">
            <el-input v-model="form.sort" />
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="form.name" />
          </el-form-item>
          <el-form-item class="save-main-style">
            <el-button
              type="primary"
              @click="addTemplateCont(0)">保 存</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="block">
        <el-tree
          :data="tree"
          :props="treeProps"
          :expand-on-click-node="false"
          node-key="id"
          default-expand-all
          empty-text
        >
          <span
            slot-scope="{ node, data }"
            class="custom-tree-node">
            <span class="name">
              <span class="sort">[{{ data.sort }}]</span>
              {{ data.name }}
            </span>
            <span>
              <el-button
                type="text"
                size="mini"
                @click="() => editNode(data.id,'edit')">编辑</el-button>
              <el-button
                type="text"
                size="mini"
                @click="() => removeNode(data.id)">删除</el-button>
              <el-button
                icon="el-icon-plus"
                type="text"
                size="mini"
                @click="() => showFlowEditHandle(data.id,'add')"
              >添加子流程</el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="showAddButton = false">返 回</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="showChildEdit"
      :title="isEditNode?'编辑子节点':'添加子节点'"
      center>
      <el-form>
        <el-form-item label="序号">
          <el-input v-model="form.sort" />
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="form.name" />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="showChildEdit = false">取 消</el-button>
        <el-button
          type="primary"
          @click="isEditNode?editTemplateCont():addTemplateCont(childContentId)">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="showPreviewFlow"
      title="模板预览">
      <el-tree
        :data="treeTemplate"
        :props="treeProps"
        :expand-on-click-node="false"
        node-key="id"
        default-expand-all
        empty-text
      >
        <span
          slot-scope="{ node, data }"
          class="custom-tree-node">
          <span class="name">
            <span class="sort">[{{ data.sort }}]</span>
            {{ data.name }}
          </span>
        </span>
      </el-tree>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="showPreviewFlow = false">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mapUtils, { $form, $http, axiosRequest } from "@/utils";

export default {
  name: "FlowTemplate",
  data() {
    return {
      listData: [],
      showAddTemplate: false,
      showFlowAdd: false,
      // 显示主流程按钮
      showAddButton: false,
      // 模板名称
      templateName: "",
      // 模板id
      templateId: "",
      isEditTemplate: false,
      // 编辑流程树表单
      form: {
        template_id: "",
        parent_id: 0,
        name: "",
        sort: "",
      },
      // 编辑标题表单
      editTitleForm: {
        id: "",
        user_id: this.$store.state.user.id,
        title: "",
      },
      tree: [],
      treeProps: {
        label: "name",
        children: "leaf",
      },
      // 树的子结构的id
      childContentId: "",
      // 编辑子结构表单
      showChildEdit: false,
      showPreviewFlow: false,
      treeTemplate: [],
      query: {
        page: 1,
        per_page: 100,
      },
      isEditNode: false,
    };
  },
  mounted() {
    this.initList();
    // console.log(JSON.stringify(this.$store.state.user));
  },
  methods: {
    columns() {
      const data = [
        { label: "序号", prop: "id" },
        { label: "标题", prop: "title" },
        { label: "责任编辑", prop: "user_name" },
        { label: "更新时间", prop: "updated_at" },
      ];
      return data;
    },

    // json转 var='edit'字符串
    jsonToEqualString(json) {
      const keys = Object.keys(json);
      // console.log(keys);
      const values = Object.values(json);
      // console.log(values);
      let valueString = "";
      for (let index = 0; index < keys.length; index++) {
        const element = keys[index];
        valueString += `${keys[index]}=${json[keys[index]]}&`;
      }
      // console.log(valueString);
      return valueString;
    },
    initList() {
      const paramsString = this.jsonToEqualString(this.query);
      axiosRequest
        .get(`/process?${paramsString}`)
        .then((res) => {
          // console.log("success-initList");
          this.listData = res.data;
        })
        .catch((error) => {
          console.log("false");
        });
    },

    showAddTemplateHandle() {
      this.templateName = "";
      this.showAddTemplate = true;
      this.isEditTemplate = false;
    },

    edit(id) {},
    deleteFlow(id) {
      this.$confirm("是否删除流程模板？").then(() => {
        axiosRequest
          .delete(`/process/${id}`)
          .then(() => {
            console.log("删除成功!");
            this.$message.success("删除成功!");
            this.initList();
          })
          .catch(() => {});
      });
    },
    cancelAdd() {
      this.showAddTemplate = false;
      this.form.index = "";
      this.form.title = "";
    },

    addTemplate() {
      if (this.templateName) {
        let params = {};
        if (this.isEditTemplate) {
          console.log("编辑模板");
          params = {
            title: this.templateName,
            id: this.templateId,
            user_id: this.$store.state.user.id,
          };
          axiosRequest
            .put(`/process/${params.id}`, params)
            .then((res) => {
              this.$message.success("修改模板标题成功!");
              this.showAddTemplate = false;
              this.initList();
            })
            .catch((error) => {
              console.log("false");
            });
        } else {
          params.title = this.templateName;
          params.user_id = this.$store.state.user.id;
          console.log(JSON.stringify(params));
          axiosRequest
            .post("/process", params)
            .then((res) => {
              this.$message.success("新建模板成功!");
              this.showAddTemplate = false;
              this.showAddButton = true;
              this.form.template_id = res.data.id;
              this.templateId = res.data.id;
              this.getContentTree(res.data.id);
              this.initList();
            })
            .catch((error) => {
              console.log("false");
            });
        }
      } else {
        this.$message.error("模板名称不能为空!");
      }
    },
    // 添加模板内容
    addTemplateCont(number) {
      if (this.form.sort && this.form.name) {
        this.form.parent_id = number;
        this.form.template_id = this.templateId;
        axiosRequest
          .post("/process_template", this.form)
          .then((res) => {
            this.$message.success("新建模板内容成功!");
            this.showAddButton = true;
            this.showFlowAdd = false;
            this.showChildEdit = false;
            this.form.sort = "";
            this.form.name = "";
            this.getContentTree(this.form.template_id);
          })
          .catch((error) => {
            this.$message.error("序号已存在!");
          });
      } else {
        this.$message.error("序号和标题不能为空!");
      }
    },
    // 编辑模板内容
    editTemplateCont() {
      if (this.form.sort && this.form.name) {
        axiosRequest
          .put(`/process_template/${this.form.id}`, this.form)
          .then((res) => {
            this.$message.success("新建模板内容成功!");
            this.showAddButton = true;
            this.showFlowAdd = false;
            this.showChildEdit = false;
            this.form.sort = "";
            this.form.name = "";
            this.getContentTree(this.templateId);
            this.initList();
          })
          .catch((error) => {

          });
      } else {
        this.$message.error("序号和标题不能为空!");
      }
    },

    // 模板内容树结构
    getContentTree(id) {
      axiosRequest
        .get(`/process_template/tree/${id}`)
        .then((res) => {
          this.tree = res.tree;
        })
        .catch((error) => {});
    },

    // 编辑标题
    editTitle(title, id) {
      console.log(title, id);
      this.templateName = title;
      this.showAddTemplate = true;
      this.isEditTemplate = true;
      this.templateId = id;
    },
    // 编辑树
    editContent(title, id) {
      console.log(title, id);
      this.getContentTree(id);
      this.showAddButton = true;
      this.templateId = id;
      this.form.template_id = id;
    },

    // 显示子节点表单
    showFlowEditHandle(id) {
      this.childContentId = id;
      this.isEditNode = false;
      this.showChildEdit = true;
      this.form.parent_id = id;
    },

    // 编辑节点
    editNode(id) {
      this.isEditNode = true;
      axiosRequest
        .get(`/process_template/${id}`)
        .then((res) => {
          this.form = res;
          this.showChildEdit = true;
        })
        .catch((error) => {});
    },

    // 删除节点
    removeNode(id) {
      axiosRequest
        .delete(`/process_template/${id}`)
        .then((res) => {
          this.$message.success("删除节点成功!");
          this.getContentTree(this.templateId);
        })
        .catch((error) => {});
    },

    lookTemplate(id) {
      this.showPreviewFlow = true;
      this.currTemplateId = id;
      axiosRequest.get(`/process_template/tree/${id}`).then((res) => {
        this.treeTemplate = res.tree;
      });
    },
  },
};
</script>

<style>
.custom-tree-node {
  font-size: 20px;
}
.custom-tree-node .name {
  margin-right: 10px;
}
.custom-tree-node .sort {
  color: blue;
  margin-right: 5px;
}
.save-main-style {
  text-align: center;
}
</style>
